<!--
 * @Author: wangwenshuai 644586996@qq.com
 * @Date: 2022-08-12 09:33:10
 * @LastEditors: wangwenshuai 644586996@qq.com
 * @LastEditTime: 2023-07-19 10:27:46
 * @FilePath: \dbarsdgs\src\view\AppMarket.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="AppMarket">
    <Banner></Banner>
    <Tabs v-if="terminal == 'pc'"></Tabs>
    <App></App>
    <!-- <ExternalApp></ExternalApp> -->
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
export default {
  mixins: [mapMixin],
  components: {
    Banner: () => import("../components/AppMarket/Banner/Banner.vue"),
    Tabs: () => import("../components/AppMarket/Tabs/Tabs.vue"),
    App: () => import("../components/AppMarket/App/App.vue"),
    ExternalApp: () =>
      import("../components/AppMarket/ExternalApp/ExternalApp.vue"),
  },
};
</script>

<style scoped lang="scss">
.AppMarket {
}
</style>